<template>
  <div
    style="position: relative;"
  >
    <div id="map-container" ref="map"></div>
    <!-- <v-overlay
      absolute
      opacity="0.5"
      :value="isLoading"
    >
      <v-progress-circular
        size="80"
        width="5"
        indeterminate
        color="wrld_red"
      >
      </v-progress-circular>
    </v-overlay> -->
  </div>
</template>

<script>
// import { shipmentHelper } from '@/_helpers'
import { mapActions, mapGetters } from 'vuex'
import point1PL from '@/assets/mapPoint1PL.svg'
import mapPoint from '@/assets/mapPoint.svg'
export default {
  name: 'ShipmentsDetailContent',
  components: {
    // ShipmentsSceduleContent
  },
  props: {},
  data () {
    return {
      herePlatform: null,
      hereRouting: null,
      hereDefaultLayer: null,
      hereMap: null,
      hereMapBehaviors: null,
      hereMapControl: null,
      hereMapUI: {
        source: null,
        mapSettings: null,
        zoom: null,
        scalebar: null,
        mode: null
      },
      hereMarker1PL: null,
      hereMarkerIcon: null,
      hereRoutingMode: 'fastest;car',
      hereRoutingRepresentation: 'display',
      hereMapGroup: null,
      hereMapRouteLine: null,
      isLoading: false,
    }
  },
  created () {},
  mounted () {
    if (this.getShipmentResourceDetails === null) {
      this.setShipmentDetails({ shipmentID: this.$route.params.shipmentID })
    } else if (this.getShipmentResourceDetails.id !== this.$route.params.shipmentID) {
      this.setShipmentDetails({ shipmentID: this.$route.params.shipmentID })
    }
  },
  methods: {
    ...mapActions({
      setShipmentSchedule: 'setShipmentSchedule',
      setShipmentDrops: 'setShipmentDrops',
      updateResource: 'updateResource',
      setShipmentDetails: 'setShipmentDetails',
      setShipmentMap: 'setShipmentMap',
      setShipmentOverviewDrops: 'setShipmentOverviewDrops',
      setHereMapObject: 'setHereMapObject',
      removeHereMapObject: 'removeHereMapObject'
    }),
    async initializeHereMap () {
      if (this.getHereMapObject != null) {
        this.herePlatform = this.getHereMapObject.herePlatform
        this.hereRouting = this.getHereMapObject.hereRouting
        this.hereDefaultLayer = this.getHereMapObject.hereDefaultLayer
        this.hereMarker1PL = this.getHereMapObject.hereMarker1PL
        this.hereMarkerIcon = this.getHereMapObject.hereMarkerIcon
        this.hereMap = this.getHereMapObject.hereMap
        this.hereMapBehaviors = this.getHereMapObject.hereMapBehaviors
      } else {
        this.herePlatform = new window.H.service.Platform({
          apikey: 'nnuTL4coE1diqkZ9mDdzC7shaHo7hJrtZmeHfd1mRzU',
          app_code: 'PROD-de11fa5f-5a46-49b7-bdc9-b09879cdb583',
          useCIT: true,
          useHTTPS: true
        })
        // Routing Service
        this.hereRouting = await this.herePlatform.getRoutingService()
        this.hereDefaultLayer = this.herePlatform.createDefaultLayers({
          lg: this.$i18n.locale
        })
        const icon1PL = await fetch(point1PL).then(r => r.text())
        const mapIcon = await fetch(mapPoint).then(r => r.text())
        this.hereMarker1PL = new window.H.map.DomIcon(icon1PL)
        this.hereMarkerIcon = new window.H.map.DomIcon(mapIcon)
        this.hereMap = new window.H.Map(
          this.$refs.map,
          this.hereDefaultLayer.vector.normal.map,
          {
            zoom: 4,
            center: { lat: 49.2306525, lng: 16.59019349999994 },
            pixelRatio: window.devicePixelRatio || 1
          }
        )
        var mapEvents = new window.H.mapevents.MapEvents(this.hereMap)
        this.hereMapBehaviors = new window.H.mapevents.Behavior(mapEvents)
        this.setHereMapObject(
          {
            hereMapObject: {
              herePlatform: this.herePlatform,
              hereRouting: this.hereRouting,
              hereDefaultLayer: this.hereDefaultLayer,
              hereMarker1PL: this.hereMarker1PL,
              hereMarkerIcon: this.hereMarkerIcon,
              hereMap: this.hereMap,
              hereMapBehaviors: this.hereMapBehaviors
            }
          }
        )
        window.addEventListener('resize', () => {
          this.hereMap.getViewPort().resize()
        })
      }
    },
    initializeHereMapUI () {
      this.hereMapUI.source = window.H.ui.UI.createDefault(this.hereMap, this.hereDefaultLayer)
      this.mapSettings = this.hereMapUI.source.getControl('mapsettings')
      this.zoom = this.hereMapUI.source.getControl('zoom')
      this.scalebar = this.hereMapUI.source.getControl('scalebar')
    },
    calculateHereMapRoute (coordinatesArray, stops, onRoutingError = this.onRoutingErrorChangeMode) {
      let routingOptions = {}
        let routingMarkers = []
        routingOptions['mode'] = this.hereRoutingMode
        routingOptions['representation'] = this.hereRoutingRepresentation
        coordinatesArray.forEach((coordinate, index) => {
          routingOptions[`waypoint${index}`] = `${coordinate.lat},${coordinate.lng}`
          let marker = null
          // console.log(stops[index].type)
          if (stops[index].type === 'LocationPickup') {
            marker = new window.H.map.DomMarker(
              {
                lat: coordinate.lat,
                lng: coordinate.lng
              },
              { icon: this.hereMarkerIcon }
            )
          } else {
            marker = new window.H.map.DomMarker(
              {
                lat: coordinate.lat,
                lng: coordinate.lng
              },
              { icon: this.hereMarker1PL }
            )
          }
          marker.setData(
            `<div class="custom--timeline__body--card">
          <div class="custom--timeline__body--card--text"><span class="custom--timeline__body--card--text__title">
          ${stops[index].location.organization != null ? stops[index].location.organization.name : ''}
          </span><span  class="custom--timeline__body--card--text__subtitle">
          ${stops[index].location.organization.ref}</span></div>
          <div class="custom--timeline__body--card--text"><span class="custom--timeline__body--card--text__title">
          ${this.$options.filters.AddressObjectToString(stops[index].location.address, [['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])}
          </span><span  class="custom--timeline__body--card--text__subtitle">
          ${stops[index].location.ref}</span></div>
          </div>`)
          routingMarkers.push(marker)
        })
      if (this.getShipmentSchedule.transport != null) {
        this.drawHereMapStraightLine(coordinatesArray)
        this.drawHereMapMarkers(routingMarkers)
        this.drawHereMapMarkersBubbles(routingMarkers)
      } else {
        this.hereRouting.calculateRoute(routingOptions, this.onRoutingResult.bind(null, routingMarkers), this.onRoutingError)
      }
    },
    onRoutingResult (markers, result) {
      result.response.route.forEach((route) => {
        this.drawHereMapRoute(route)
        this.drawHereMapMarkers(markers)
        this.drawHereMapMarkersBubbles(markers)
      })
    },
    onRoutingErrorChangeMode (error) {
      console.log(error)
      this.hereRoutingMode = 'fastest;car'
      this.calculateHereMapRoute(this.shipmentLocations.map(({ _geoloc }) => _geoloc), this.shipmentLocations)
    },
    onRoutingError (error) {
      console.log(error)
    },
    drawHereMapRoute (route) {
      let routeShape = route.shape
      let lineString = new window.H.geo.LineString()
      routeShape.forEach((point) => {
        lineString.pushLatLngAlt(point.split(',')[0], point.split(',')[1])
      })
      let routeLine = new window.H.map.Polyline(lineString, {
        style: {
          strokeColor: '#4CAF50',
          fillColor: 'transparent',
          lineWidth: 3
        }
      })
      if (this.hereMapRouteLine != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapRouteLine)
        this.hereMapRouteLine = null
      }
      this.hereMapRouteLine = routeLine
      this.hereMap.addObject(routeLine)
      this.hereMap.getViewModel().setLookAtData({
        bounds: routeLine.getBoundingBox(),
        zoom: 4
      })
    },
    drawHereMapStraightLine (locations) {
      const lineString = new H.geo.LineString()
      locations.forEach((item) => {
        lineString.pushPoint({ lat: item.lat, lng: item.lng })
      })
      if (this.hereMapRouteLine != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapRouteLine)
        this.hereMapRouteLine = null
      }
      const routeLine = new H.map.Polyline(
        lineString, { style: { lineWidth: 4 } },
      )
      this.hereMapRouteLine = routeLine
      this.hereMap.addObject(routeLine)
    },
    drawHereMapMarkers (markers) {
      let group = new window.H.map.Group()
      if (this.hereMapGroup != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapGroup)
        this.hereMapGroup = null
      }
      this.hereMapGroup = group
      group.addObjects(markers)
      this.hereMap.addObject(group)
    },
    drawHereMapMarkersBubbles (markers) {
      // let group = new window.H.map.Group()
      markers.forEach((marker, index) => {
        marker.addEventListener('tap', (evt) => {
          let bubble = new window.H.ui.InfoBubble(marker.getGeometry(), {
            content: marker.getData()
          })
          this.hereMapUI.source.addBubble(bubble)
        })
      })
    },
    isCoordinatesInDrops (val) {
      if (val[0].origin != null) {
        if (val[0].origin.coordinates != null) {
          return true
        }
      }
      return false
    },
    removeHereMapMarkersAndRoutes () {
      if (this.hereMapRouteLine != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapRouteLine)
        this.hereMapRouteLine = null
      }
      if (this.hereMapGroup != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapGroup)
        this.hereMapGroup = null
      }
    }
  },
  computed: {
    ...mapGetters([
      'getShipmentResourceDrops',
      'getShipmentResourceSchedule',
      'getShipmentResourceDropsDetails',
      'getShipmentResourceDetails',
      'getSelectedResourceID',
      'getHereMapObject',
      'getShipmentSchedule',
      'getShipmentFetchingError'
    ])
  },
  watch: {
    getShipmentResourceDetails: {
      deep: true,
      immediate: true,
      handler (val) {
        if(this.$route.path.indexOf('shipments-new') >= 0){
          if (val != null) {
            this.isEmptyShipment = false
            this.setShipmentSchedule({ shipmentID: val.id })
          }
        }
      }
    },
    getShipmentSchedule: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.stops != null) {
          this.initializeHereMap().then(() => {
            this.initializeHereMapUI()
            this.calculateHereMapRoute(
              val.stops.map(({ location }) => location.coordinates),
              val.stops
            )
            this.isLoading = false
          })
        } else {
          this.isLoading = true
          this.removeHereMapMarkersAndRoutes()
        }
      }
    },
    getShipmentFetchingError: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val != null) {
          if (this.hereMapRouteLine != null && this.hereMap != null) {
            this.hereMap.removeObject(this.hereMapRouteLine)
            this.hereMapRouteLine = null
          }
          if (this.hereMapGroup != null && this.hereMap != null) {
            this.hereMap.removeObject(this.hereMapGroup)
            this.hereMapGroup = null
          }
        }
      }
    }
  },
  beforeDestroy () {
    this.removeHereMapObject()
  }
}
</script>

<style lang="scss" scoped>
#map-container {
  width: 100%;
  height: calc(100vh - 120px);
}
</style>
